import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/gbbd_more",
    name: "Gbbd",
    component: () => import("../views/gbbd_more.vue"),
  },
  {
    path: "/zygd_more",
    name: "Zygd",
    component: () => import("../views/zygd_more.vue"),
  },
  {
    path: "/cwts_more",
    name: "Cwts",
    component: () => import("../views/cwts_more.vue"),
  },
  {
    path: "/cwts_details",
    name: "Detail",
    component: () => import("../views/cwts_details.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
